module.exports = __webpack_public_path__ + "img/juxue3.52302b28.png";